/*
 * action types
 */

export const REPLACE = "REPLACE_STOCK_CONTROLS";
export const CLEAR = "CLEAR_STOCK_CONTROLS";
export const SET_STOCK_CONTROLS_FILTERS = "SET_STOCK_CONTROLS_FILTERS";
export const SET_STOCK_CONTROLS_PAGESIZE = "SET_STOCK_CONTROLS_PAGESIZE";
export const SET_STOCK_CONTROLS_PAGENUMBER = "SET_STOCK_CONTROLS_PAGENUMBER";
export const DELETE_STOCK_CONTROL = "DELETE_STOCK_CONTROL";

/*
 * action creators
 */

export const Replace = (values, totalResults, totalPage) => ({ 
    type : REPLACE,
    stockControls: values,
    totalResults,
    totalPage,
});

export const Clear = () => ({
    type: CLEAR
})

export const SetPageSize = (pageSize) => ({
    type: SET_STOCK_CONTROLS_PAGESIZE,
    pageSize
})

export const SetPageNumber = (pageNumber) => ({
    type: SET_STOCK_CONTROLS_PAGENUMBER,
    pageNumber
})

export const SetFilters = (filters) => ({
    type: SET_STOCK_CONTROLS_FILTERS,
    filters
})